import { IAlarmSituation } from '@/pages/Processes/AlarmSituations/alarmSituations.types.ts'
import { ITableField } from '@/shared/Tables/Table'
import SystemEventTypeTag from '../SystemEventTypeTag'
import EquipmentAddressLink from '../../../Equipment/components/Common/EquipmentAddressLink'
import { format } from 'date-fns'
import OrganizationLink from '@/pages/Organizations/components/OrganizationLink'
import SystemEventTableDescription from '@/pages/SystemEvents/components/SystemEventsTable/SystemEventTableDescription'
import { ISystemEvent } from '../../systemEvents.types'

const systemEventsTableFields: ITableField<ISystemEvent, keyof ISystemEvent | IAlarmSituation['name']>[] = [
  {
    key: 'createdAt',
    clientSideOrdering: true,
    width: '180px',
    header: 'Дата события',
    getter: (it) => format(it.createdAt, 'dd.MM.yyyy, HH:mm:ss'),
    sortGetter: (it) => it.createdAt,
  },
  {
    key: 'message',
    clientSideOrdering: true,
    width: '200px',
    header: 'Сообщение',
    getter: (it) => <SystemEventTableDescription notification={it} />,
    sortGetter: (it) => it.description,
  },
  {
    key: 'type',
    clientSideOrdering: true,
    width: '200px',
    header: 'Тип',
    getter: (it) => <SystemEventTypeTag notification={it} />,
    sortGetter: (it) => it.type,
  },
  {
    key: 'adress',
    clientSideOrdering: true,
    width: '200px',
    header: 'Устройство',
    getter: (it) => {
      switch (it.type) {
        case 'LP_ERROR':
        case 'ALARM_SITUATION_INCIDENT':
        case 'MOVED_TO_MAINTENANCE':
        case 'MOVED_FROM_MAINTENANCE_TO_NORMAL':
          return <EquipmentAddressLink equipmentId={it.payload.equipmentId} />
        default:
          return '—'
      }
    },
    sortGetter: () => 1,
  },
  {
    key: 'user',
    clientSideOrdering: true,
    width: '180px',
    header: 'Пользователь',
    getter: (it) => (it.causedBy?.name ? it.causedBy.name : '—'),
    sortGetter: (it) => it.causedBy?.name,
  },
  {
    key: 'organization',
    clientSideOrdering: true,
    width: '200px',
    header: 'Организация',
    getter: (it) => <OrganizationLink organizationId={it.relatedOrganizationId} />,
    sortGetter: (it) => it.relatedOrganizationId,
  },
]

export default {
  admin: systemEventsTableFields,
  client: systemEventsTableFields.filter((p) => p.key !== 'organization'),
}
